import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_profit_center_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  coa_guid: fromDatatype.VarcharDatatypeInterface;
  create_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_group: fromDatatype.GuidDataFieldInterface;
  level_value: fromDatatype.IntegerDatatypeInterface;
  ext_code1: fromDatatype.VarcharDatatypeInterface;
  ext_code2: fromDatatype.VarcharDatatypeInterface;
  ext_code3: fromDatatype.VarcharDatatypeInterface;
  ext_code4: fromDatatype.VarcharDatatypeInterface;
  ext_code5: fromDatatype.VarcharDatatypeInterface;
  ext_code1_name: fromDatatype.VarcharDatatypeInterface;
  ext_code2_name: fromDatatype.VarcharDatatypeInterface;
  ext_code3_name: fromDatatype.VarcharDatatypeInterface;
  ext_code4_name: fromDatatype.VarcharDatatypeInterface;
  ext_code5_name: fromDatatype.VarcharDatatypeInterface;
  ext_code1_description: fromDatatype.TextDatatypeInterface;
  ext_code2_description: fromDatatype.TextDatatypeInterface;
  ext_code3_description: fromDatatype.TextDatatypeInterface;
  ext_code4_description: fromDatatype.TextDatatypeInterface;
  ext_code5_description: fromDatatype.TextDatatypeInterface;
}

export class bl_fi_mst_profit_center_RowClass
  implements bl_fi_mst_profit_center_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  coa_guid: fromDatatype.VarcharDatatypeInterface;
  create_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_group: fromDatatype.GuidDataFieldInterface;
  level_value: fromDatatype.IntegerDatatypeInterface;
  ext_code1: fromDatatype.VarcharDatatypeInterface;
  ext_code2: fromDatatype.VarcharDatatypeInterface;
  ext_code3: fromDatatype.VarcharDatatypeInterface;
  ext_code4: fromDatatype.VarcharDatatypeInterface;
  ext_code5: fromDatatype.VarcharDatatypeInterface;
  ext_code1_name: fromDatatype.VarcharDatatypeInterface;
  ext_code2_name: fromDatatype.VarcharDatatypeInterface;
  ext_code3_name: fromDatatype.VarcharDatatypeInterface;
  ext_code4_name: fromDatatype.VarcharDatatypeInterface;
  ext_code5_name: fromDatatype.VarcharDatatypeInterface;
  ext_code1_description: fromDatatype.TextDatatypeInterface;
  ext_code2_description: fromDatatype.TextDatatypeInterface;
  ext_code3_description: fromDatatype.TextDatatypeInterface;
  ext_code4_description: fromDatatype.TextDatatypeInterface;
  ext_code5_description: fromDatatype.TextDatatypeInterface;
}
